import cf from './cf';
import i1zv4 from './i1zv4_20211024';

export default class cdr extends i1zv4 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      name: '予約状況カレンダー',
      class: 'cdr',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
